import React from 'react';

const ULAS = (props) => {

	// eslint-disable-next-line jsx-a11y/iframe-has-title
	return (<iframe id="mapFrame" width="100%" height="100%" allowfullscreen="true" src="https://opac.fslib.com.cn/szlibOPAC/NTRdrBookRetr.do"></iframe>);
}

export default ULAS;